import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SpeakerIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="
          M28.671 8.454a13.5 13.5 0 0 1 0 19.092
          M24.6945 12.432a7.875 7.875 0 0 1 0 11.136
          M10.125 12.375l7.08-7.08
          a1.125 1.125 0 0 1 1.92 0.795v23.82
          a1.125 1.125 0 0 1-1.92 0.795l-7.08-7.08
          H6.765
          c-1.32 0-2.556-0.76-2.907-2.031
          A13.5135 13.5135 0 0 1 3.375 18
          c0-1.245 0.168-2.45 0.483-3.594
          0.834-1.104 2.445-1.575 3.6525-1.575
          H10.125Z"
      />
    </SvgIcon>
  );
};

export default SpeakerIcon;
